var level2Task3 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="8cRGjDR3Oj5fkz*97(5G">x</variable>
    <variable id=",5t|*hSfXY3RI9^bMjz,">y</variable>
  </variables>
  <block type="variables_set" id="kKxPu!P8:1!^Nrx_?D-s" x="13" y="37">
    <field name="VAR" id="8cRGjDR3Oj5fkz*97(5G">x</field>
    <value name="VALUE">
      <block type="math_number" id="_FI.49J5:(AzW76h~NmH">
        <field name="NUM">0</field>
      </block>
    </value>
    <next>
      <block type="variables_set" id="Zyr#b6T7@FQ9bw$~6E#T">
        <field name="VAR" id=",5t|*hSfXY3RI9^bMjz,">y</field>
        <value name="VALUE">
          <block type="math_number" id="|z#p2YUcJ+8VfiP0gqG?">
            <field name="NUM">1</field>
          </block>
        </value>
        <next>
          <block type="text_print" id="QE]4L!#X)1w{JkHuh;-W">
            <value name="TEXT">
              <block type="logic_compare" id="X)5UL7g@g@hDeaGMQ4f">
                <field name="OP">EQ</field>
                <value name="A">
                  <block type="variables_get" id="OL!L~7N38Xi;uRJK]iOa">
                    <field name="VAR" id="8cRGjDR3Oj5fkz*97(5G">x</field>
                  </block>
                </value>
                <value name="B">
                  <block type="variables_get" id="8o9LOD#.v;dpKo5^!D,(">
                    <field name="VAR" id=",5t|*hSfXY3RI9^bMjz,">y</field>
                  </block>
                </value>
              </block>
            </value>
          </block>
        </next>
      </block>
    </next>
  </block>
</xml>
`
export default level2Task3